import Image from "next/image";
import Link from "next/link";
// molecules
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
// hooks
import { useBudouX } from "@/hooks/useBudouX";
// icons
import { faFaceSmileRelaxed } from "@fortawesome/pro-thin-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// images
import { LeadContact } from "@/components/molecules/parts/LeadContact";
import bgContact from "/public/bg-contact.webp";

const Contact = ({
  children = "システム構築のご相談やご依頼など、お気軽にお問い合わせください。",
}) => {
  const { parse } = useBudouX();

  return (
    <>
      <Link href="/contact/">
        <div className="group relative z-20 max-w-full cursor-pointer justify-start bg-gradient-to-r from-grd-base to-grd-to px-6 py-10 transition-all hover:brightness-110 sm:px-8 md:px-12 md:py-20 lg:py-24">
          <Container>
            <Inner className="flex flex-col items-center justify-between gap-6 sm:flex-row md:gap-0 lg:gap-0">
              <div className="flex flex-col gap-4">
                <div className="relative ">
                  <LeadContact className="h-auto fill-white 2xs:w-[88%] xs:w-[70%] md:w-[76%] lg:w-[64%]" />
                </div>
                <p
                  className="
                  font-bold
                  leading-relaxed
                  text-white
                  fluid-text-[13px,18px]
                "
                >
                  {children}
                </p>
              </div>
              <div className="flex min-h-[160px] min-w-[160px] items-center justify-center rounded-full bg-white text-sec transition-all group-hover:text-hov md:min-h-[200px] md:min-w-[200px] lg:min-h-[240px] lg:min-w-[240px]">
                <h4 className="text-center leading-none fluid-text-[40px,100px]">
                  <FontAwesomeIcon icon={faFaceSmileRelaxed} />
                  <p className="mt-3 text-md font-bold">Contact US</p>
                </h4>
              </div>
            </Inner>
          </Container>
          <div className="absolute bottom-[0px] left-0 aspect-4.5/1 w-full contrast-200 md:block">
            <Image
              src={bgContact}
              alt="Get in touch with ToccaSystems"
              quality={80}
              layout="fill"
            />
          </div>
        </div>
      </Link>
    </>
  );
};

export default Contact;
